import { CheckCircleFilled, CloseCircleFilled, ContactsFilled, StopOutlined, SyncOutlined } from '@ant-design/icons'
import { TripStatusIcon } from '@constants/TripStatusIcons'
import { BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import React, { useMemo } from 'react'

export const Status = ({ data, status }) => {
  if (!status) return null
  const statusIcon = useMemo(() => {
    switch (status) {
      case 'Received':
      case 'Pending':
        return (
          <Vertical
            style={{
              backgroundColor: 'var(--gray-600)',
              borderRadius: '50%',
              height: 15,
              width: 15,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SyncOutlined style={{ color: '#fff', fontSize: '9px' }} />
          </Vertical>
        )
      case 'Accepted':
      case 'Acknowledged':
        return <CheckCircleFilled style={{ color: 'var(--gray-600', fontSize: '14px' }} />
      case 'Dispatched':
        return <ContactsFilled style={{ color: 'var(--gray-600)', fontSize: '14px' }} />
      case 'In Progress':
        return <TripStatusIcon status={data.status_detail} />
      case 'Delivered':
        return <CheckCircleFilled style={{ fontSize: '14px' }} />
      case 'Rejected':
        return (
          <Vertical
            style={{
              backgroundColor: 'var(--theme-error)',
              borderRadius: '50%',
              height: 15,
              width: 15,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <StopOutlined style={{ color: '#fff', fontSize: '9px' }} />
          </Vertical>
        )
      default:
        return <CloseCircleFilled style={{ color: 'var(--gray-600', fontSize: '14px' }} />
    }
  }, [status, data.status_detail])
  const statusColor = useMemo(() => {
    switch (status) {
      case 'Received':
      case 'Pending':
      case 'Accepted':
      case 'Acknowledged':
      case 'Dispatched':
      case 'Loading':
      case 'Dropping':
      case 'Driving':
        return 'var(--gray-200)'
      case 'Delivered':
      case 'Rejected':
        return ''
      default:
        return 'var(--gray-200)'
    }
  }, [status])

  return (
    <BBDTag
      error={status === 'Rejected'}
      success={status === 'Delivered'}
      theme1={status !== 'Rejected' && status !== 'Delivered'}
      style={{ maxWidth: 120, backgroundColor: statusColor, border: 'none' }}
    >
      <Horizontal verticalCenter>
        <Vertical className={'mb-1 mt-1'} style={{ maxWidth: 18, maxHeight: 18 }}>
          {statusIcon}
        </Vertical>
        <Vertical className={'ml-2'}>
          <Texto>{status}</Texto>
        </Vertical>
      </Horizontal>
    </BBDTag>
  )
}
